<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>
                <b-link
                        :to="{name:'Jobs'}"
                        class="btn btn-primary btn-round">
                    back
                </b-link>
            </template>
        </navbar>

        <h2>Users Marketing Request ({{count}})</h2>

        <b-card>
            <b-input v-model="searchInput" placeholder="search..."></b-input>
        </b-card>

        <b-card>
            <div class="table-responsive">
                <b-table-simple v-if="users.length > 0">
                    <b-thead>
                        <b-tr>
                            <b-th>name</b-th>
                            <b-th>email</b-th>
                            <b-th>signup users</b-th>
                            <b-th>orders count</b-th>
                            <b-th></b-th>
                        </b-tr>
                    </b-thead>

                    <b-tbody>
                        <b-tr v-for="(item,index) in getUsersSearch" :key="index">
                            <td>
                                {{item.name}}
                            </td>
                            <td>
                                {{item.email}}
                            </td>
                            <td>
                                {{item.signup_users}}
                            </td>
                            <td>
                                {{item.orders_count}}
                            </td>
                            <td>
                                <b-link :to="{name:'PromotionUserDetailsJob',params:{'id':item.id}}"
                                        class="btn btn-success">{{$t('details')}}
                                </b-link>
                            </td>
                        </b-tr>
                    </b-tbody>

                </b-table-simple>

            </div>
        </b-card>


    </div>
</template>

<script>
    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'


    export default {
        name: "Users",
        components: {Navbar},
        data() {
            return {
                users: [],
                count: 0,
                searchInput: null
            }
        },
        methods: {
            getUsers() {
                this.$Progress.start();
                Http.get(Http.apiurl() + 'job/users')
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.users = response.data.data.users;
                            this.count = response.data.data.count;
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            }
        },
        computed:{
            getUsersSearch() {
                if (this.searchInput === null) {
                    return this.users;
                }

                return this.users.filter(item => {
                    return item.name.toLowerCase().match(this.searchInput.toLowerCase()) ||
                        item.email.toLowerCase().match(this.searchInput.toLowerCase())
                })
            },
        },
        created() {
            this.getUsers();
        }
    }
</script>

<style scoped>

</style>